<script setup lang="ts">
import { brandLogoUrl } from '@/stores/theme';

defineProps<{ size?: number; mono?: boolean }>();
</script>

<template>
    <span class="brand-logo" :class="{ 'brand-logo--mono': mono }" :style="{ fontSize: (size ?? 20) + 'px' }">
        <img class="brand-logo__mark" :src="brandLogoUrl" alt="" aria-hidden="true" />
        <span class="brand-logo__text">
            <span>CaviCode</span><span class="brand-logo__suffix"> Network</span>
        </span>
    </span>
</template>

<style scoped>
.brand-logo {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: var(--ink);
    user-select: none;
}
.brand-logo__mark {
    width: 36px;
    height: 36px;
    display: block;
    flex-shrink: 0;
    object-fit: contain;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.18));
}
.brand-logo__text {
    font-family: var(--font-brand);
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0;
    color: currentColor;
}
.brand-logo__suffix {
    color: var(--accent);
}
.brand-logo--mono .brand-logo__mark {
    filter: grayscale(1);
    opacity: 0.85;
}
</style>